module.exports = __webpack_public_path__ + "static/BioBeechos-OpenGraph-Image-4c8d1bac63bddf3e284a4a35fb6016ca.png";